import { Box, Flex, Heading, HStack, Link, Text, VStack } from "@chakra-ui/react";
import NextLink from 'next/link';

import PressShare from "@components/PressShare";
import { headerHeight } from "@lib/headerHeight";

const PressHeader = ({
	heading,
  summary,
	url = null,
}) => {

	return (
		<Box
			backgroundColor="#EDEADF"
			paddingTop={`${headerHeight ? headerHeight : headerHeight + 40}px`}
			paddingBottom="80px"
			width="full"
			pos="relative"
		>
			<Box
				display="flex"
				maxWidth="1245px"
				paddingTop={{ base: "30px", md: "48px" }}
				flexDirection={{base: "column", md: "row"}}
				marginX="auto"
				paddingX={{md: "30px"}}
				>
					<Box
						width={{ md: 3 / 4 }}
						marginBottom={{ base: "30px", md: "0" }}
						paddingX={{ base: "30px", md: "0" }}
					>
						<VStack gap="0px">
							<HStack align="left" width="full" marginBottom="34px">
								<Link as={NextLink} href="/about/news" className="hover-underline">
									<Text as="span">Newsroom</Text>
									</Link>
									<Text pb="2">/</Text>
								<Link as={NextLink} href="/about/news/category/press-releases" className="hover-underline">
									<Text as="span">Press Releases</Text>
									</Link>
									<Text pb="2">/</Text>
							</HStack>
							<Heading
								as="h2"
								color="#05B39E"
                fontWeight="700"
								fontSize={{ base: "46px", md: "46px" }}
								lineHeight={{base: "60px", md: "60px" }}
							>
								{heading}
							</Heading>
              <HStack align="left" width="full" marginTop="22px">
               <Text fontSize="19px" lineHeight="26px">{summary}</Text>
              </HStack>
						</VStack>
					</Box>
					<Box
					width={{ md: 1 / 4 }}
					display="flex"
					flexDirection="column"
					justifyContent="end"
					paddingX={{base: "30px", md: "0"}}
					>
					<Flex justify={{base: "start", md: "end"}}>
						<PressShare url={url} title={heading} />
					</Flex>
				</Box>
			</Box>
		</Box>
	);
};

export default PressHeader;
